import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { GroupService } from 'app/main/settings/accounts/groups/services/groups-api.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return UserGroupLegacyComponent; }),
    multi: true
};
var UserGroupLegacyComponent = /** @class */ (function () {
    function UserGroupLegacyComponent(fuseTranslationLoaderService, groupsService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.groupsService = groupsService;
        this.groups = new Array();
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    UserGroupLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges
            .pipe(filter(function (searchTerm) {
            return !!searchTerm;
        }), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.groups = [];
            return _this.groupsService.loadData({
                where: {
                    name_contains: searchTerm
                },
                options: {
                    orderBy: 'name_asc',
                    offset: 0,
                    limit: 10
                }
            });
        }))
            .subscribe(function (result) {
            _this.loading = false;
            _this.groups = result.items;
        });
    };
    UserGroupLegacyComponent.prototype.writeValue = function (groupId) {
        var _this = this;
        if (groupId) {
            this.groupsService.getGroupById(groupId).then(function (group) {
                _this.selectedGroup = group;
                _this.hasSelectedGroup = true;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectGroup();
        }
    };
    UserGroupLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    UserGroupLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    UserGroupLegacyComponent.prototype.setSelectedGroup = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedGroup = this.groups.find(function (group) { return group.id === _this.inputValue.value; });
            this.hasSelectedGroup = true;
            this.inputValue.setErrors(null);
        }
    };
    UserGroupLegacyComponent.prototype.deselectGroup = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedGroup = null;
        this.hasSelectedGroup = false;
        this.inputValue.setErrors(null);
    };
    return UserGroupLegacyComponent;
}());
export { UserGroupLegacyComponent };
